app.controller('teacherAppExercisePerformCtrl', [
    '$scope', '$rootScope', '$http', '$mdDialog', 'gameService', '$state', '$stateParams', '$timeout', '$log', function ($scope, $rootScope, $http, $mdDialog, gameService, $state, $stateParams, $timeout, $log) {
        var vm = this;

        $scope.$on('$viewContentLoaded', function () {
            $timeout(function() {
                if (window.MathJax != null) {
                    $log.debug("teacherAppExercisePerformCtrl: viewContentLoaded typeset");
                    window.MathJax.Hub.Queue(
                        ["Typeset",MathJax.Hub],
                        [function() { $scope.$apply(function() {
                            vm.showMathLoader = false;
                        }); }]
                    );
                } else {
                    $log.debug("teacherAppExercisePerformCtrl: no window.MathJax, skipping typeset");
                }
            }, 1);
        });

        vm.gameService = gameService;
        vm.gameState = gameService.getGameState();
        vm.exercise = gameService.exerciseWithIndex($stateParams.id);
        vm.question = gameService.lookupQuestion(vm.exercise.index, $stateParams.question);

        vm.progressIndex = 1 + $stateParams.question;
        vm.progressCount = 1 + vm.exercise.questions.length + 1 + vm.exercise.evaluationQuestions.length + 1;
        vm.progressArray = new Array(vm.progressCount);
        
    	vm.points = 40;

    	vm.activeAnswers = [ true, true, true, true ];
        vm.done = false;

        var parent = angular.element("#performarrow")[0];
        vm.arrow = new TivoliArrow(parent);
        vm.arrow.start();

        $scope.$on('$destroy', function() {
            vm.arrow.stop();
        	vm.arrow = null;
        });

        vm.popupShown = false;
        vm.answer = null;
        vm.answerIndex = 0;

        vm.helpAvailable = vm.question.extraButtonText.length > 0;

        vm.showMathLoader = vm.helpAvailable;

    	vm.performAnswer = function(idx) {
    		var answerObj = vm.question.answers[idx];

            // Don't do anything if the answer isn't active.
            if (!vm.activeAnswers[idx]) {
                return;
            }

            if (vm.question.answers[idx].correct) {
                vm.activeAnswers = [ false, false, false, false ];
                vm.done = true;
                return;
			}

            vm.answerIndex = idx;
            vm.answer = answerObj;
           	vm.popupShown = true;
    	}

    	vm.hidePopup = function() {
    		var idx = vm.answerIndex;

			vm.activeAnswers[idx] = false;
            vm.points -= 10;
            vm.popupShown = false;
    	}

        vm.helpShown = vm.helpAvailable;
        vm.firstRun = true;
        vm.showHelp = function() {
        	vm.helpShown = true;
            vm.firstRun = false;
        }

        vm.hideHelp = function() {
        	vm.helpShown = false;
            vm.firstRun = false;

            $timeout(function() {
                var elements = angular.element(".helpinner");
                if (elements.length > 0) {
                    elements[0].scrollTo(0, 0);
                }
            }, 0); // XXX: must match the transition time for .helppopover.
        }

        vm.next = function() {
            if (!vm.done) {
                return;
            }

        	vm.gameState.score += vm.points;

    		// Go to question?
    		if ($stateParams.question < vm.exercise.questions.length - 1) {
    			vm.gameState.exerciseIndex = $stateParams.id; // XXX
    			vm.gameState.questionIndex = $stateParams.question + 1; // XXX

    			vm.gameService.setGameState(vm.gameState).then(function() {
    				$state.go('teacherapp.exerciseperform', { id: vm.gameState.exerciseIndex, question: vm.gameState.questionIndex });
    			})
			// Go to evaluation interstitial?
    		} else if ($stateParams.question === vm.exercise.questions.length - 1) {
                vm.gameState.exerciseIndex = $stateParams.id; // XXX
                vm.gameState.questionIndex = $stateParams.question + 1; // XXX

    			vm.gameService.setGameState(vm.gameState).then(function() {
    				$state.go('teacherapp.exerciseevalbegin', { id: $stateParams.id });
    			});
    		}
    	}
    }
]);